import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  text-align: center;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  text-align: center;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  flex-direction: column;\n  display: flex;\n  flex-grow: 1;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  & > * {\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { ICON_SIZE } from '../../constants';
import SvgIcon from '../../SvgIcon';
import { BUTTON_ICON_HORIZONTAL_MARGIN } from '../constants';
import { Small as SmallTypographySize } from '../../Typography/constants/small.size';
import { ExtraSmall as ExtraSmallTypographySize } from '../../Typography/constants/extra-small.size';
import { baseTextStyle } from '../../Typography/style/base';
import { absoluteCenteredStyle } from '../../tokens/centered';
import InfoWithIconsSimple from '../../Info/InfoWithIcons/InfoWithIconsSimple';
import { lineHeight } from '../../style/line-height';
import { fontSize } from '../../style/font-size';
var ICON_TOP_POSITION = {
  small: 0,
  medium: {
    xs: 0,
    lg: -1
  }
};
var FONT_SIZE = {
  medium: SmallTypographySize.fontSize,
  small: ExtraSmallTypographySize.fontSize
};
var LINE_HEIGHT = {
  medium: SmallTypographySize.lineHeight,
  small: ExtraSmallTypographySize.lineHeight
};
var StyledIcon = styled(SvgIcon)(_templateObject(), absoluteCenteredStyle);
var StyledWrapper = styled.span(_templateObject2());
var StyledTitle = styled.span(_templateObject3());
var StyledSubTitle = styled.span(_templateObject4(), baseTextStyle, function (_ref) {
  var _ref$size = _ref.size,
      value = _ref$size === void 0 ? 'medium' : _ref$size;
  return fontSize(FONT_SIZE[value] || FONT_SIZE.medium);
}, function (_ref2) {
  var _ref2$size = _ref2.size,
      value = _ref2$size === void 0 ? 'medium' : _ref2$size;
  return lineHeight(LINE_HEIGHT[value] || LINE_HEIGHT.medium);
});

var ButtonContent = function ButtonContent(_ref3) {
  var _ref3$vertical = _ref3.vertical,
      vertical = _ref3$vertical === void 0 ? false : _ref3$vertical,
      _ref3$noIconWrapper = _ref3.noIconWrapper,
      noIconWrapper = _ref3$noIconWrapper === void 0 ? false : _ref3$noIconWrapper,
      _ref3$noChildren = _ref3.noChildren,
      noChildren = _ref3$noChildren === void 0 ? false : _ref3$noChildren,
      icon = _ref3.icon,
      _ref3$iconSize = _ref3.iconSize,
      iconSize = _ref3$iconSize === void 0 ? ICON_SIZE : _ref3$iconSize,
      _ref3$iconRightSize = _ref3.iconRightSize,
      iconRightSize = _ref3$iconRightSize === void 0 ? ICON_SIZE : _ref3$iconRightSize,
      iconTopPosition = _ref3.iconTopPosition,
      iconRightTopPosition = _ref3.iconRightTopPosition,
      iconRight = _ref3.iconRight,
      _ref3$iconMargin = _ref3.iconMargin,
      iconMargin = _ref3$iconMargin === void 0 ? BUTTON_ICON_HORIZONTAL_MARGIN : _ref3$iconMargin,
      _ref3$iconRightMargin = _ref3.iconRightMargin,
      iconRightMargin = _ref3$iconRightMargin === void 0 ? BUTTON_ICON_HORIZONTAL_MARGIN : _ref3$iconRightMargin,
      title = _ref3.title,
      subTitle = _ref3.subTitle,
      _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? 'medium' : _ref3$size,
      content = _ref3.content;
  return /*#__PURE__*/React.createElement(InfoWithIconsSimple, {
    icon: !icon ? null : noIconWrapper ? icon : /*#__PURE__*/React.createElement(StyledIcon, {
      size: iconSize,
      color: null
    }, icon),
    iconRight: !iconRight ? null : noIconWrapper ? iconRight : /*#__PURE__*/React.createElement(StyledIcon, {
      size: iconRightSize,
      color: null
    }, iconRight),
    iconMargin: iconMargin,
    iconRightMargin: iconRightMargin,
    iconTopPosition: iconTopPosition != null ? iconTopPosition : ICON_TOP_POSITION[size] || ICON_TOP_POSITION.medium,
    iconRightTopPosition: iconRightTopPosition != null ? iconRightTopPosition : ICON_TOP_POSITION[size] || ICON_TOP_POSITION.medium,
    vertical: vertical,
    noChildren: noChildren
  }, title || subTitle ? /*#__PURE__*/React.createElement(StyledWrapper, null, (title || content) && (!subTitle ? title || content : /*#__PURE__*/React.createElement(StyledTitle, {
    size: size
  }, title || content)), subTitle && /*#__PURE__*/React.createElement(StyledSubTitle, {
    size: size
  }, subTitle)) : content);
};

export default ButtonContent;